import { createSelector } from "reselect";
import { assessmentVersionSelector } from "src/selectors/config_selectors";

export const etiologyVerifiedQuestionEnabledSelector = createSelector(
  assessmentVersionSelector,
  version => version == "v5Ashn"
);
